<template>
  <v-card :loading="loading" :rounded="UI.BORDER_RADIUS" :disabled="isDisabled">
    <slot />
  </v-card>
</template>

<script lang="ts" setup>
import { UI } from '@/layouts/constants/Layout';

type Props = {
  loading?: boolean;
  isDisabled?: boolean;
};

defineProps<Props>();
</script>
